import { render, staticRenderFns } from "./modals.vue?vue&type=template&id=8e2d5f88"
import script from "./modals.vue?vue&type=script&lang=js"
export * from "./modals.vue?vue&type=script&lang=js"
import style0 from "./modals.vue?vue&type=style&index=0&id=8e2d5f88&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports